var _linearGradient, _path, _path2, _linearGradient2, _path3, _linearGradient3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectronicSubmission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_e2c90600a79d56c607310f6cbd5da9a5c13d004f0e5e4f70be17068c52a70d30",
    gradientUnits: "userSpaceOnUse",
    x1: -3569.092,
    y1: -13.591,
    x2: -3568.092,
    y2: -13.591
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M78.58 23.773h50.819c5.449 0 9.865 4.417 9.865 9.865v82.673c0 5.449-4.417 9.865-9.865 9.865H66.637c-5.449 0-9.865-4.417-9.865-9.865v-70.73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M78.422 23.921L57.087 45.256h21.335z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_e2c90600a79d56c607310f6cbd5da9a5c13d004f0e5e4f70be17068c52a70d30",
    gradientUnits: "userSpaceOnUse",
    x1: -1618.699,
    y1: 252.189,
    x2: -1577.858,
    y2: 252.189,
    gradientTransform: "rotate(90 -658.598 1008.875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_e2c90600a79d56c607310f6cbd5da9a5c13d004f0e5e4f70be17068c52a70d30)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M101.741 50.024h-7.46v25.597h-9.015l13.366 12.744 12.278-13.054h-9.169z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_e2c90600a79d56c607310f6cbd5da9a5c13d004f0e5e4f70be17068c52a70d30",
    gradientUnits: "userSpaceOnUse",
    x1: 68.283,
    y1: 99.869,
    x2: 127.239,
    y2: 99.869
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_2_e2c90600a79d56c607310f6cbd5da9a5c13d004f0e5e4f70be17068c52a70d30)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M69.533 96.141h56.456v7.456H69.533z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronicSubmission);
export default __webpack_public_path__ + "static/media/electronicSubmission.1fb4afb16345f7e676ca7235fdc03d2d.svg";
export { ForwardRef as ReactComponent };